import { render, staticRenderFns } from "./cpt-intelligent.vue?vue&type=template&id=38572f5a&scoped=true"
import script from "./cpt-intelligent.vue?vue&type=script&lang=js"
export * from "./cpt-intelligent.vue?vue&type=script&lang=js"
import style0 from "./cpt-intelligent.vue?vue&type=style&index=0&id=38572f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38572f5a",
  null
  
)

export default component.exports